import ReactModal from 'react-modal'
import { BoxModal } from '../../../components/boxModal'
import { PixKey } from '../pix-key'
import { TbCircleKey } from 'react-icons/tb'
import { useState } from 'react';
import * as RadioGroup from '@radix-ui/react-radio-group';
import { css } from "@emotion/react";
import BeatLoader from "react-spinners/BeatLoader";
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { getAll, CreateKey } from '../../../services/pix.service';
import { MessageToCache, MethodToCache, PullerGetAllPixKeyList } from '../../../services/puller.service';
import { useNavigate } from 'react-router';

import './styles.css'

export function KeysModal({ isOpen, setKeysModalIsOpen, refreshKeys }) {
  const [keyIsCreated, setKeyIsCreated] = useState(false)
  const [isWaitDBChange, setIsWaitDBChange] = useState(false);
  const [rows, setRows] = useState([]);
  const [loader, setLoader] = useState(false);
  const [typeKey, setTypeKey] = useState(4);

  const navigate = useNavigate()

  function handleCloseModal() {
    setKeyIsCreated(false)
    setKeysModalIsOpen(false)
  }

  function handleCreateNewKey(e) {
    e.preventDefault()
    console.log(typeKey)

    CreateKey(typeKey, '', navigate)
      .then(response => {
        if(response.isCreated){
          MethodToCache(setIsWaitDBChange);
          MessageToCache("Nova chave criada com sucesso!")
          PullerGetAllPixKeyList();
        }

        setKeyIsCreated(true)
      });
  }

  const getKeys = async () => {
    if (localStorage.getItem("taxNumber") == "12345678900") {
      setRows([
        {
          id: 259,
          personId: 332,
          type: "4",
          key: "ae42d3d8-b36c-4a8e-awc9-d89f6d43fb9e",
          status: "0",
          createdAt: "2023-09-26 13:47:00",
          updatedAt: "2023-09-26 13:47:00",
        },
        {
          id: 224,
          personId: 332,
          type: "2",
          key: "teste@teste.com.br",
          status: "0",
          createdAt: "2023-08-01 13:30:00",
          updatedAt: "2023-08-09 13:13:48",
        },
      ]);
      return;
    }
    setLoader(true);

    try {
      const response = await getAll();
      //console.log("@@@", response);
      setRows(response);
      setLoader(false);
      refreshKeys();
    } catch (error) {
      toast.error("Erro ao recuperar as chaves, tente novamente");
      setLoader(false);
    }
  };

  useEffect(() => {
    getKeys();
    //console.log("///////////////", isWaitDBChange);
    if(isWaitDBChange){
      setIsWaitDBChange(false);
    }
  }, [isWaitDBChange]);

  const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
    margin-top: 3em;
  `;

  return (
    <ReactModal
      isOpen={isOpen}
      className={"keys-modal"}
      overlayClassName={"overlay-keys-modal"}
    >
      {
        keyIsCreated 
        ? (
          <BoxModal 
            icon='circleCheck'
            title='Chave Cadastrada!' 
            description='Agora é só compartilhar sempre que você quiser receber PIX'
            maxWidth={724} 
            close={handleCloseModal}
          >
            <div className='pix-new-key-container'>
              <div className="pix-new-key-info">
                <TbCircleKey size={40} />

                <div className="pix-new-key-content">
                  <strong>Chave aleatória</strong>
                </div>
              </div>

              <span className='pix-new-key-status'>
                Cadastro em andamento
              </span>
            </div>
          </BoxModal>
        ) : (
          <BoxModal title='Gerenciamento de Chaves Pix' maxWidth={684} maxHeight={801} close={handleCloseModal}>
            <div className='keys-modal-content'>
              <div className='keys-modal-section'>
                <h3>Minhas Chaves</h3>

                <div className='my-keys'>
                  {
                    !loader
                    ? (
                      <>
                        {
                          rows.length
                          ? (
                            rows.map((item) => (
                              <PixKey 
                                key={item.id}
                                id={item.id}
                                type={item.type}
                                keyValue={item.key}
                                getKeys={getKeys}
                              />
                            ))
                          ) : (
                            <span>Vazio...</span>
                          )
                        } 
                      </>
                    ) : (
                      <BeatLoader 
                        color={"var(--secondary-color)"} 
                        loading={loader} 
                        css={override} 
                        size={20} 
                      />
                    )
                  }
                </div>
              </div>

              <div className='keys-modal-section'>
                <h3>Cadastrar nova Chave</h3>

                <form className='new-key-container' onSubmit={handleCreateNewKey}>
                  <RadioGroup.Root 
                    className="new-key-radio-root" 
                    defaultValue="4"
                    value={typeKey} 
                    onValueChange={(value) => setTypeKey(value)}
                    id='cpf' 
                    required
                  >
                    {/* <div className='new-key-radio-item'>
                      <RadioGroup.Item className="new-key-radio-button" value="cpf" id="cpf">
                        <RadioGroup.Indicator className="new-key-radio-indicator" />
                      </RadioGroup.Item>
                      <label className="new-key-radio-label" htmlFor="cpf">
                        CPF
                        <strong>144.255.366-98</strong>
                      </label>
                    </div>

                    <div className='new-key-radio-item'>
                      <RadioGroup.Item className="new-key-radio-button" value="tel" id="tel">
                        <RadioGroup.Indicator className="new-key-radio-indicator" />
                      </RadioGroup.Item>
                      <label className="new-key-radio-label" htmlFor="tel">
                        Celular
                        <strong>(21) 94567-9874</strong>
                      </label>
                    </div> */}

                    {/* <div className='new-key-radio-item'>
                      <RadioGroup.Item className="new-key-radio-button" value="3" id="email">
                        <RadioGroup.Indicator className="new-key-radio-indicator" />
                      </RadioGroup.Item>
                      <label className="new-key-radio-label" htmlFor="email">
                        E-mail
                        <strong>fulanodetal@gmail.com</strong>
                      </label>
                    </div>  */}

                    <div className='new-key-radio-item'>
                      <RadioGroup.Item className="new-key-radio-button" value={4} id="random">
                        <RadioGroup.Indicator className="new-key-radio-indicator" />
                      </RadioGroup.Item>
                      <label className="new-key-radio-label" htmlFor="random">
                        <strong>Chave aleatória</strong>
                      </label>
                    </div>
                  </RadioGroup.Root>

                  <button className='new-key-button'>Cadastrar chave pix</button>
                </form>
              </div>
            </div>
          </BoxModal>
        )
      }
    </ReactModal>
  )
}